import { GlobalStoreState } from './global-store';

export interface State {
  readonly [GlobalStoreState.StateKey]: GlobalStoreState.State;
}
